import { render, staticRenderFns } from "./CookieConsent.vue?vue&type=template&id=23c944b2&scoped=true"
import script from "./CookieConsent.vue?vue&type=script&lang=ts"
export * from "./CookieConsent.vue?vue&type=script&lang=ts"
import style0 from "./CookieConsent.vue?vue&type=style&index=0&id=23c944b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c944b2",
  null
  
)

export default component.exports